module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/13-2fa3572d48c9e0654198bae63ef57678.jpg";